import { render, staticRenderFns } from "./doctorProduct.vue?vue&type=template&id=7e352ce0&scoped=true&"
import script from "./doctorProduct.vue?vue&type=script&lang=js&"
export * from "./doctorProduct.vue?vue&type=script&lang=js&"
import style0 from "./doctorProduct.vue?vue&type=style&index=0&id=7e352ce0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e352ce0",
  null
  
)

export default component.exports